import styled from 'styled-components';

export const StyledSelect = styled.select`
  height: 40px;
  width: 100%;
  border: 0;
  color: #63636d;
  font-size: 13px;
  outline: 0;
  text-indent: ${(props) => (props.indent ? props.indent : '0')};
`;

export const SelectHeader = styled.div`
  color: ${({ theme }) => theme.COLOR_TABLE_DARK};
  font-size: 15px;
  font-weight: normal;
  margin: 0;
`;

export const Container = styled.div`
  margin-bottom: 10px;
`;

export const Icon = styled.span`
  position: absolute;
  left: 10px;
  z-index: 99;
`;

export const Select = styled.div`
  margin: 0;
  border-bottom: 0.5px solid #adacb7;
  display: ${(props) => (props.className === 'hide' ? 'none' : '')};
  display: flex;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const DateDropDown = styled.div`
  padding: 0;
  height: fit-content;
  display: flex;
  justify-content: center;

  div {
    padding: 0;
    display: flex;
    margin: 0 5px 0 0 !important;
  }

  select {
    padding: 0 !important;
    width: fit-content;
    border-radius: 5px;
    height: 30px;
  }
`;

export const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;

export const StyledBorderSelect = {
  Container,
  SelectHeader,
  StyledSelect,
  Icon,
  Select,
  DateDropDown,
  Validation,
};

export default StyledBorderSelect;
